<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <!-- <router-link to="/manage">SKU管理</router-link>
      <span class="arrow"><i class="iconfont icon-arrow"></i></span>
      <span>商品管理</span> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <router-link
            :to="`/purchaseIndex/pManageSet/${params.keyword}`"
            v-if="params.keyword != '' && dataList.length > 0"
            ><p class="flex-rowl">
              <i class="iconfont icon-xinzeng"></i> 发起采购申请
            </p></router-link
          >
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入SKU编码/ISBN编码查找匹配商品"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      采购订单号：
                      <span>{{ item.ID }}</span>
                    </p>
                    <!-- <p>
                      商品名称：
                      <span>{{ item.commodityname }}</span>
                    </p> -->
                    <p>
                      SKU编码：
                      <span>{{ item.SKU }}</span>
                    </p>
                    <p>
                      ISBN编码：
                      <span>{{ item.ISBN }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      属性标签：<span>{{ item.Tags }}</span>
                    </p>
                    <p>
                      属性值：<span>{{ item.TagValues }}</span>
                    </p>
                    <p>
                      采购数量：<span>{{ item.Quantity }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      采购金额：<span>{{ item.Amount }}</span>
                    </p>
                    <p>
                      已入库数量：<span>{{ item.QuantityReceived }}</span>
                    </p>
                    <p>
                      采购付款形式：<span>{{
                        item.PaymentMethod == 1 ? "先款后货" : "货到付款"
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="edit_group">
                  <div
                    class="editBtn"
                    :class="{ active: item.ManagerApproval != 1 }"
                    @click="handleCheckPuracsh(item.ID, item.ManagerApproval)"
                    v-if="spAuth.isViewrange"
                  >
                    {{
                      item.ManagerApproval == 1
                        ? "审核通过"
                        : item.ManagerApproval == 2
                        ? "审核不通过"
                        : "待审核"
                    }}
                  </div>
                  <div class="editBtn active" @click="handleToast" v-if="zfAuth.isViewrange">
                    待支付
                  </div>
                  <div class="editBtn" @click="handleWare(item.ID)" v-if="rkglAuth.isViewrange">
                    入库管理
                  </div>
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { queryShop, getMenuAuthThree, getPurchaseList } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "pManageIndex",
  data() {
    return {
      // 发起采购申请权限
      cgsqAuth: "",
      // 入库管理权限
      rkglAuth: "",
      // 待审批
      spAuth: "",
      // 待支付
      zfAuth: "",

      searchTxt: "",
      detail: "",

      qyid: "",

      brandList: "",
      dataList: [],
      loading: false,
      params: {
        page: 1,
        pagesize: 10,
        keyword: "",
        openid: "",
        opentype: "", // 申请人的用户类型 = weixin 微信用户，qiye 企业用户 houtai 后台用户 accountid 用户账户id
      },
      listTotal: 0,

      // 采购
      isShow: false,
      purchaseId: "",
      ManagerApproval: "",
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
    } else {
      this.qyid = 0;
    }

    this.params.openid = userInfo.openid;
    this.params.opentype = userInfo.accountid;
    this.getMenuAuthThree();
    let {keyword} = this.$route.params
    if(keyword != '') {
      this.params.keyword = keyword
      this.handleSearch()
    }
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthThree() {
      let menuItem = this.$store.state.menuItem;
      let roleId = this.$store.state.USERINFO.qy.roleid;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length === 0) return;
        res.forEach((item) => {
          if (item.funcname === "发起采购申请按钮") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.cgsqAuth = item;
          }
          if (item.funcname === "入库管理") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.rkglAuth = item;
          }
          if (item.funcname === "待审批（采购计划状态）") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.spAuth = item;
          }
          if (item.funcname === "待支付（采购计划状态）") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.zfAuth = item;
          }
        });
      });
    },

    // 获取商品详情
    handleSearch() {
      let { params } = this;
      if (params.keyword == "") {
        this.detail = "";
        this.dataList = [];
        return;
      }
      this.loading = true;
      queryShop({ keyword: params.keyword, openid: this.OPENID }).then((res) => {
        if (res.id) {
          this.detail = res;
          this.getPurchaseList();
        } else {
          this.loading = false;
        }
      });
    },
    // 采购主管审核采购列表
    handleCheckPuracsh(id, type) {
      let { spAuth } = this;
      if (!spAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      if (type == 1) {
        return;
      }
      this.purchaseId = id;
      this.isShow = true;
    },

    // 获取采购列表
    getPurchaseList() {
      let { params } = this;
      getPurchaseList(params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total
        this.loading = false;
      });
    },
     // 入库管理
    handleWare(id) {
      let { rkglAuth } = this;
      if (!rkglAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$router.push(`${rkglAuth.pagepath}/${id}`);
    },
    handleToast() {
      let { zfAuth } = this;
      if (!zfAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$message.warning("即将开放");
    },

    // 分页
    handleCurrentChange() {},
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .pic_box {
      width: 100px;
      height: 100px;
      .iconfont {
        font-size: 40px;
      }
    }
    .edit_group {
      .editBtn {
        text-align: center;
        padding: 8px 25px;
        margin: 0 0 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>